import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import DataTable from "../../../component/element/table";
import { ColumnDef } from "@tanstack/react-table";
import { FaUser, FaUserLock } from "react-icons/fa6";
import { get_company_branch_users } from "../../../services/apis/companies";
import { IEmployee, ICompanyBranch } from "../../../store/types/companies";

type ICompanyBranchUserProps = {
  companyId: number;
};

const CompanyBranchUser: React.FC<ICompanyBranchUserProps> = ({
  companyId,
}) => {
  const dispatch = useAppDispatch();

  const { users, branches, loading } = useAppSelector(({ companies }) => ({
    users:
      companies.employeesCompanyId === companyId ? companies.employees : [],
    branches:
      companies.branchesCompanyId === companyId ? companies.branches : [],
    loading:
      companies.employeesCompanyId === companyId &&
      companies.employeesLoading,
  }));

  // Fetch users on mount or when companyId changes
  useEffect(() => {
    if (Number.isInteger(companyId) && companyId > 0) {
      get_company_branch_users(companyId, dispatch);
    }
  }, [companyId, dispatch]);

  const columns: ColumnDef<IEmployee>[] = [
    {
      accessorKey: "profile.name",
      header: () => <span>Name</span>,
    },
    {
      accessorKey: "email",
      header: () => <span>Email</span>,
    },
    {
      accessorKey: "profile.phone",
      header: () => <span>Phone</span>,
    },
    {
      accessorKey: "role",
      header: () => <span>Role</span>,
      cell: ({ getValue }) => {
        const role = getValue() as string;
        return role === "1" ? (
          <FaUserLock size={20} color="red" />
        ) : (
          <FaUser size={20} color="blue" />
        );
      },
    },
    {
      accessorKey: "profile.branch_id",
      header: () => <span>Branch</span>,
      cell: ({ row }) => {
        const branch = branches.find(
          (item: ICompanyBranch) => item.id === row.original.profile.branch_id,
        );
        return branch?.name || "—";
      },
    },
  ];

  return loading ? (
    <div className="py-12 text-center text-gray-500">Loading employees...</div>
  ) : (
    <DataTable columns={columns} data={users} hasPaginate={false} />
  );
};

export default CompanyBranchUser;
